import { Component, OnInit } from '@angular/core';
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "app/login/login.service";
import { LaudosTecnicosModel } from "../laudos-tecnicos/laudos-tecnicos.model";
import { LaudosTecnicosService } from "../laudos-tecnicos/laudos-tecnicos.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MercadoriasService } from "../mercadorias/mercadorias.service";
import { FaturasService } from "../faturas/faturas.service";
import { ClientesService } from "../clientes/clientes.service";

declare let swal, $: any;

@Component({
  selector: 'app-financeiro-laudos-tecnicos-cliente',
  templateUrl: './financeiro-laudos-tecnicos-cliente.component.html'
})
export class FinanceiroLaudosTecnicosClienteComponent extends Components implements OnInit {

  formAlterarValor: FormGroup;
  formFaturar: FormGroup;
  formPesquisaAvancada: FormGroup;
  filtroPesquisa = { "data_de": "", "data_ate": "", "id_produto": "", "referencia": "", "nf_importacao": "", "cliente": "" };

  laudos: LaudosTecnicosModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false };

  listMercadorias = [];
  idCliente: string;
  cliente: any;

  selecionarTodos: boolean = false;
  selecionados: any = {};

  alterar_valor: any = {
    "id_laudo": null,
    "valor": ""
  };

  faturar = {
    "id_laudo": null,
    "data": ""
  };

  faturarEmMassa = {
    "data": ""
  };

  carregandoBotaoFaturar: boolean = false;
  carregandoBotaoAlterarValor: boolean = false;

  constructor(
    formBuilder: FormBuilder,
    private laudosService: LaudosTecnicosService,
    private mercadoriasService: MercadoriasService,
    private faturasService: FaturasService,
    private clientesService: ClientesService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    private route: ActivatedRoute,
    public func: Funcoes,
    public loginService: LoginService
  ) {
    super();

    let date = new Date().toISOString();
    this.filtroPesquisa.data_de = date.substr(0, 8) + '01';
    this.filtroPesquisa.data_ate = date.substr(0, 10);

    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        if (data.privilegios[i].id_acao == '29') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      data_de: [],
      data_ate: [],
      id_produto: [],
      referencia: [],
      nf_importacao: []
    });

    this.formAlterarValor = formBuilder.group({
      valor: []
    });

    this.formFaturar = formBuilder.group({
      data: [],
      data_faturar_massa: []
    });

    this.mercadoriasService.get(null, null, ['id', 'nome_pt'])
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;
        });
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.idCliente = params['id_cliente'];
      this.filtroPesquisa.cliente = this.idCliente;

      if (this.idCliente) {
        this.clientesService.getById(this.idCliente)
          .subscribe(
            json => {
              if (json && json.Payload && json.Payload.length > 0) {
                this.cliente = json.Payload[0];
              }
            },
            error => { }
          );
      }

      let filtroSalvo = this.carregaFiltro();
      if (filtroSalvo) {
        this.filtroPesquisa = filtroSalvo;
        this.filtroPesquisa.cliente = this.idCliente;
        this.formPesquisaAvancada.patchValue(filtroSalvo);
      }
      this.carregandoTabela = true;
      this.getPage(1);
    });
  }

  delete(laudo) {
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarLaudoTecnico') + (laudo.referencia || ''),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        let index = self.laudos.indexOf(laudo);
        self.laudos.splice(index, 1);

        self.laudosService.apagar(laudo.id_laudo_tecnico)
          .subscribe(res => {
          },
            err => {
              self.laudos.splice(index, 0, laudo);
              self.func.showErro(err.json());
            });
      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};
    filtros['id_cliente'] = this.idCliente;

    if (this.filtroPesquisa.data_de && this.filtroPesquisa.data_ate) {
      filtros['data_descarga'] = 'bt:' + this.filtroPesquisa.data_de + '|' + this.filtroPesquisa.data_ate;
    } else {
      if (this.filtroPesquisa.data_de) {
        filtros['data_descarga'] = 'ge:' + this.filtroPesquisa.data_de;
      }
      if (this.filtroPesquisa.data_ate) {
        filtros['data_descarga'] = 'le:' + this.filtroPesquisa.data_ate;
      }
    }

    if (this.filtroPesquisa.id_produto != '') {
      filtros['id_produto'] = this.filtroPesquisa.id_produto;
    }

    if (this.filtroPesquisa.referencia != '') {
      filtros['referencia'] = "**:" + this.filtroPesquisa.referencia;
    }

    if (this.filtroPesquisa.nf_importacao != '') {
      filtros['nf_importacao'] = "**:" + this.filtroPesquisa.nf_importacao;
    }

    filtros['faturado'] = '0'; // Apenas não faturados
    filtros['id_status'] = 2; // Apenas Online / Revisados

    this.laudosService.getPaginacao(pagina, this.itensPorPagina, ['produto', 'cliente', 'cliente.moeda', 'exportador', 'unidade', 'status'], filtros)
      .subscribe(data => {
        this.laudos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  enviaParaCliente(id) {
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaEnviarFichaCliente'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        self.laudosService.enviarLaudoParaCliente(id).subscribe(res => { }, err => { self.func.showErro(err.json()); });
      });
  }

  alteraStatus(id_laudo, id_status) {
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaAlterarStatus'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true,
    },
      function () {
        self.laudosService.setStatus(id_laudo, id_status)
          .subscribe(res => {
            swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.statusAlterado'), "success");
            self.getPage(self.paginaAtual);
          },
            error => {
              swal(self.func.traduzir('front.erro'), self.func.traduzir('front.statusNaoAlterado'), "error");
              self.func.showErro(error.json());
            });
      });
  }

  modalPesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada() {
    if (this.filtroPesquisa.data_de && !this.filtroPesquisa.data_ate) {
      this.filtroPesquisa.data_ate = new Date().toISOString().split('T')[0];
      this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada() {
    this.filtroPesquisa = { "data_de": "", "data_ate": "", "id_produto": "", "cliente": this.idCliente, "referencia": "", "nf_importacao": "" };
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

  modalAlterarValor(id_laudo, valor, cliente: any = null) {
    this.alterar_valor["id_laudo"] = id_laudo;
    let valorFinal = valor;
    if (valorFinal === null || valorFinal === undefined || valorFinal === '') {
      if (cliente && cliente.valor_laudostecnicos !== undefined && cliente.valor_laudostecnicos !== null && cliente.valor_laudostecnicos !== '') {
        valorFinal = cliente.valor_laudostecnicos;
      } else if (this.cliente && this.cliente.valor_laudostecnicos !== undefined && this.cliente.valor_laudostecnicos !== null && this.cliente.valor_laudostecnicos !== '') {
        valorFinal = this.cliente.valor_laudostecnicos;
      }
    }
    this.alterar_valor["valor"] = valorFinal !== null && valorFinal !== undefined && valorFinal !== '' ? Number(valorFinal) : '';
    this.formAlterarValor.patchValue({ valor: this.alterar_valor["valor"] });
    $('#modalAlterarValor').modal('show');
  }

  alterarValor() {
    this.carregandoBotaoAlterarValor = true;
    this.laudosService.setValor(this.alterar_valor["id_laudo"], this.alterar_valor["valor"])
      .subscribe(res => {
        this.carregandoBotaoAlterarValor = false;
        swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.statusAlterado'), "success");
        this.getPage(this.paginaAtual);
        $('#modalAlterarValor').modal('hide');
      },
        error => {
          this.carregandoBotaoAlterarValor = false;
          this.func.showErro(error.json());
          $('#modalAlterarValor').modal('hide');
        });
  }

  limpaAlteraValor() {
    this.alterar_valor = { "id_laudo": null, "valor": "" };
    this.formAlterarValor.patchValue({ valor: '' });
    $('#modalAlterarValor').modal('hide');
  }

  modalFaturar(id_laudo) {
    this.faturar["id_laudo"] = id_laudo;
    this.faturar["data"] = new Date().toISOString().substr(0, 10);
    $('#modalFaturar').modal('show');
  }

  confirmarFaturar() {
    this.carregandoBotaoFaturar = true;
    this.laudosService.faturarLaudo(this.faturar["id_laudo"], this.faturar["data"])
      .subscribe(res => {
        this.carregandoBotaoFaturar = false;
        swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.faturadoSucesso'), "success");
        this.getPage(this.paginaAtual);
        $('#modalFaturar').modal('hide');
      },
        error => {
          this.carregandoBotaoFaturar = false;
          this.func.showErro(error.json());
        });
  }

  limpaFaturar() {
    this.faturar = { "id_laudo": null, "data": "" };
    $('#modalFaturar').modal('hide');
  }

  marcarTodos(event) {
    this.selecionarTodos = event.target.checked;
    this.laudos.forEach(laudo => {
      this.selecionados[laudo.id_laudo_tecnico] = this.selecionarTodos;
    });
  }

  marcarItem(laudo, event) {
    this.selecionados[laudo.id_laudo_tecnico] = event.target.checked;

    if (!event.target.checked) {
      this.selecionarTodos = false;
    } else {
      let todosMarcados = true;
      for (let l of this.laudos) {
        if (!this.selecionados[l.id_laudo_tecnico]) {
          todosMarcados = false;
          break;
        }
      }
      this.selecionarTodos = todosMarcados;
    }
  }

  modalFaturarEmMassa() {
    let selecionadosIds = this.getSelecionadosIds();
    if (selecionadosIds.length == 0) {
      swal(this.func.traduzir('front.erro'), this.func.traduzir('front.selecionePeloMenosUmItem'), "error");
      return;
    }

    this.faturarEmMassa["data"] = new Date().toISOString().substr(0, 10);
    $('#modalFaturarEmMassa').modal('show');
  }

  confirmarFaturarEmMassa() {
    this.carregandoBotaoFaturar = true;
    let selecionadosIds = this.getSelecionadosIds();

    this.faturasService.faturarLaudosTecnicosAvulsos(selecionadosIds, this.faturarEmMassa["data"])
      .subscribe(res => {
        this.carregandoBotaoFaturar = false;
        swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.faturadoSucesso'), "success");
        this.getPage(this.paginaAtual);
        this.selecionados = {};
        this.selecionarTodos = false;
        $('#modalFaturarEmMassa').modal('hide');
      },
        error => {
          this.carregandoBotaoFaturar = false;
          this.func.showErro(error.json());
        });
  }

  private getSelecionadosIds(): string[] {
    let ids = [];
    for (let id in this.selecionados) {
      if (this.selecionados[id]) {
        ids.push(id);
      }
    }
    return ids;
  }

}




// WEBPACK FOOTER //
// ./src/app/financeiro/financeiro-laudos-tecnicos-cliente.component.ts